export default __webpack_public_path__ + "9dbb7243738d2745c0d8ee87f6907aa8.png";